<template>
  <div id="certificate" class="certificate-container" :style="{ backgroundImage: `url(${backgroundImageUrl})` }">
    <!-- 证书内容将覆盖在背景图片上 -->
    <div class="certificate-content">
      <!-- 左侧内容 -->
      <div class="left-content">
        <div class="student-name-left">{{ studentName }}</div>
        <!-- <div class="completion-year">{{ completionYear }}</div>
        <div class="completion-month">{{ completionMonth }}</div>
        <div class="completion-day">{{ completionDay }}</div> -->
      </div>
      
      <!-- 右侧内容 -->
      <div class="right-content">
        <div class="student-name-right">{{ studentName }}</div>
        <div class="gender">{{ gender }}</div>
        <div class="id-number">{{ idNumber }}</div>
        <div class="certificate-number">{{ certificateNumber }}</div>
        <div class="issue-date-formatted">{{ formattedIssueDate }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Certificate',
  data() {
    return {
      backgroundImageUrl: require('../assets/img/初级证书.jpg')
    }
  },
  props: {
    studentName: {
      type: String,
      default: '李四'
    },
    gender: {
      type: String,
      default: '男'
    },
    idNumber: {
      type: String,
      default: '123456789012345678'
    },
    certificateNumber: {
      type: String,
      default: 'CAMH2024001'
    },
    completionDate: {
      type: String,
      default: ''
    },
    issueDate: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 解析完成日期
    completionYear() {
      if (!this.completionDate) return new Date().getFullYear()
      return new Date(this.completionDate).getFullYear()
    },
    completionMonth() {
      if (!this.completionDate) return new Date().getMonth() + 1
      return new Date(this.completionDate).getMonth() + 1
    },
    completionDay() {
      if (!this.completionDate) return new Date().getDate()
      return new Date(this.completionDate).getDate()
    },
    // 解析发证日期
    issueYear() {
      if (!this.issueDate) return new Date().getFullYear()
      return new Date(this.issueDate).getFullYear()
    },
    issueMonth() {
      if (!this.issueDate) return new Date().getMonth() + 1
      return new Date(this.issueDate).getMonth() + 1
    },
    issueDay() {
      if (!this.issueDate) return new Date().getDate()
      return new Date(this.issueDate).getDate()
    },
    // 格式化发证日期为2025-10-10格式
    formattedIssueDate() {
      if (!this.issueDate) {
        const now = new Date()
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
      }
      const date = new Date(this.issueDate)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>
.certificate-container {
  width: 800px;
  height: 600px;
  margin: 0 auto;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.certificate-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  padding: 40px;
}

/* 左侧内容区域 */
.left-content {
  position: absolute;
  top: 50%;
  left: 15%;
  transform: translateY(-50%);
  width: 35%;
}

/* 右侧内容区域 */
.right-content {
  position: absolute;
  top: 35%;
  right: -2.5%;
  transform: translateY(-50%);
  width: 35%;
}

/* 左侧内容样式 */
.student-name-left {
  position: absolute;
  top: 50px;
  left: -50px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.completion-year {
  position: absolute;
  top: 58px;
  left: 140px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.completion-month {
  position: absolute;
  top: 58px;
  left: 202px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.completion-day {
  position: absolute;
  top: 58px;
  left: 246px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* 右侧内容样式 */
.student-name-right {
  position: absolute;
  top: -55px;
  left: 0;
  font-size: 16px;
  color: #333;
}

.gender {
  position: absolute;
  top: 11px;
  left: 0;
  font-size: 16px;
  color: #333;
}

.id-number {
  position: absolute;
  top: 75px;
  left: 0;
  font-size: 16px;
  color: #333;
}

.certificate-number {
  position: absolute;
  top: 140px;
  left: 0;
  font-size: 16px;
  color: #333;
}

.issue-date-formatted {
  position: absolute;
  top: 200px;
  left: 0;
  font-size: 16px;
  color: #333;
}

/* 打印样式 */
@media print {
  .certificate-container {
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
    background-size: contain !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .certificate-content {
    padding: 20px;
  }
  
  /* 打印时调整左侧姓名位置 */
  .student-name-left {
    top: 45px !important;
    left: -75px !important;
    font-size: 16px !important;
  }
  
  /* 打印时调整左侧日期位置 */
  .completion-year {
    top: 55px !important;
    left: 100px !important;
    font-size: 14px !important;
  }
  
  .completion-month {
    top: 55px !important;
    left: 160px !important;
    font-size: 14px !important;
  }
  
  .completion-day {
    top: 55px !important;
    left: 200px !important;
    font-size: 14px !important;
  }
  
  /* 打印时调整右侧内容位置 */
  .student-name-right {
    top: -10px !important;
    font-size: 14px !important;
  }
  
  .gender {
    top: 25px !important;
    font-size: 14px !important;
  }
  
  .id-number {
    top: 60px !important;
    font-size: 14px !important;
  }
  
  .certificate-number {
    top: 95px !important;
    font-size: 14px !important;
  }
  
  .issue-date-formatted {
    top: 160px !important;
    font-size: 14px !important;
  }
}
</style>

